// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { FormSection, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import InputCheckbox from '../../../../../../common/atoms/InputCheckbox';
import withStyles from '../../../../../../common/hoc/withStyles';
import Espot from '../../../../../../common/molecules/Espot';
import { getIconPath, getLocator, isCanada } from '../../../../../../../utils';
import styles from '../styles/EmailSignUpCheckBox.view.style';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '../../../../../../../utils/labels/labelUtilty';
import { EMAIL_SIGNUP_LABELS } from '../../../container/Checkout.labels';

class EmailSignUpCheckBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getBrandChecked = this.getBrandChecked.bind(this);
    this.state = {
      isCheckedTCP: this.props?.isCheckedTCP || false,
      isCheckedGYM: this.props?.isCheckedGYM || false,
      isCheckedSNJ: false,
    };
  }

  getBrandChecked = (isGymboree, isChildrenPalace, isSnJ) => {
    this.state.isChecked = isGymboree || isChildrenPalace || isSnJ;
  };

  handleChangeTCP = (e, value) => {
    this.state.isCheckedTCP = value;
  };

  handleChangeGYM = (e, value) => {
    this.state.isCheckedGYM = value;
  };

  handleChangeSNJ = (e, value) => {
    this.state.isCheckedSNJ = value;
  };

  render() {
    const {
      className,
      fieldName,
      isLoginV2FlowEnabled,
      emailSignUpFlags: { emailSignUpTCP, emailSignUpGYM, emailSignUpSNJ } = {},
    } = this.props;
    const {
      lbl_shipping_emailSignUpHeader_ca_new: emailSignUpHeaderNew,
      lbl_shipping_emailSignUpHeader: emailSignUpHeader,
      lbl_shipping_emailSignUpSubHeader: emailSignUpSubHeader,
    } = getLabelFromCopyOrFromTranslation('checkout.shipping', EMAIL_SIGNUP_LABELS);
    const emailSignUpDisclaimer = getDynamicLabelValues(
      'dynamic.checkout_d.lbl_shipping_emailSignUpDisclaimer'
    );
    const isChecked = this.state.isCheckedTCP || this.state.isCheckedGYM || this.state.isCheckedSNJ;
    const emailSignUpHeaderLabel = isLoginV2FlowEnabled ? emailSignUpHeaderNew : emailSignUpHeader;

    return (
      <FormSection name="emailSignUp">
        <div className={className}>
          <BodyCopy
            dataLocator="email-signUp-heading"
            fontSize="fs16"
            fontFamily="secondary"
            fontWeight="bold"
            className="signupcheckbox-header"
          >
            {emailSignUpHeaderLabel}
          </BodyCopy>
          <BodyCopy
            dataLocator="email-signUp-subHeading"
            fontSize="fs14"
            fontFamily="secondary"
            className="email-signUp-subHeading"
            fontWeight="regular"
          >
            {emailSignUpSubHeader}
          </BodyCopy>
          <div className="email-checkbox-container">
            <div className="email-checkbox-list">
              <Field
                dataLocator="signUp-checkbox-field"
                name={`${fieldName}TCP`}
                component={InputCheckbox}
                className="email-signup-tcp checkbox"
                defaultChecked={emailSignUpTCP}
                onChange={this.handleChangeTCP}
              >
                <BodyCopy
                  dataLocator="pickup-email-signUp-heading-lbl"
                  fontSize="fs16"
                  fontFamily="secondary"
                  fontWeight="regular"
                >
                  <Image
                    className="tcp-logo image"
                    src={getIconPath('header__brand-tab-tcp')}
                    data-locator={getLocator(className)}
                  />
                </BodyCopy>
              </Field>
              <Field
                dataLocator="signUp-checkbox-field"
                name={`${fieldName}GYM`}
                component={InputCheckbox}
                className="email-signup-gym checkbox"
                defaultChecked={emailSignUpGYM}
                onChange={this.handleChangeGYM}
              >
                <BodyCopy
                  dataLocator="pickup-email-signUp-heading-lbl"
                  fontSize="fs16"
                  fontFamily="secondary"
                  fontWeight="regular"
                >
                  <Image
                    className="gym-logo image"
                    src={getIconPath('header__brand-tab-gym')}
                    data-locator={getLocator(className)}
                  />
                </BodyCopy>
              </Field>
              {!isCanada() && (
                <Field
                  dataLocator="signUp-checkbox-field"
                  name={`${fieldName}SNJ`}
                  component={InputCheckbox}
                  className="email-signup-snj checkbox"
                  defaultChecked={emailSignUpSNJ}
                  onChange={this.handleChangeSNJ}
                >
                  <BodyCopy
                    dataLocator="pickup-email-signUp-heading-lbl"
                    fontSize="fs16"
                    fontFamily="secondary"
                    fontWeight="regular"
                  >
                    <Image
                      className="snj-logo image"
                      src={getIconPath('header__brand-tab-snj')}
                      data-locator={getLocator(className)}
                    />
                  </BodyCopy>
                </Field>
              )}
            </div>
            {isChecked && (
              <div className="email-signup-text">
                <Espot richTextHtml={emailSignUpDisclaimer} />
              </div>
            )}
          </div>
        </div>
      </FormSection>
    );
  }
}

EmailSignUpCheckBox.propTypes = {
  emailSignUpFlags: PropTypes.shape({}).isRequired,
  className: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  emailSignUpCaRichText: PropTypes.string,
  onCheckBoxChange: PropTypes.bool.isRequired,
};

EmailSignUpCheckBox.defaultProps = {
  emailSignUpCaRichText: null,
};

export default withStyles(EmailSignUpCheckBox, styles);
export { EmailSignUpCheckBox as EmailSignUpCheckBoxVanilla };
